import React, { useState } from 'react';
import type { ResetPasswordSectionProps } from '../../types/travel-payment';

const ResetPasswordSection: React.FC<ResetPasswordSectionProps> = ({ 
  onSubmit, 
  onBackToLogin, 
  className = '' 
}) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(email);
  };

  const handleBackToLogin = () => {
    setEmail('');
    onBackToLogin();
  };

  return (
    <div className={`integrated-section reset-password-section ${className}`}>
      <h2 className="integrated-section-title">Reset Password</h2>
      
      <form className="integrated-section-form" onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="integrated-section-input"
          required
        />
        
        <button 
          type="submit" 
          className="integrated-section-button button-gradient"
        >
          Send Reset Link
        </button>
      </form>
      
      <div 
        className="integrated-back-link"
        onClick={handleBackToLogin}
      >
        ← Back to Login
      </div>
    </div>
  );
};

export default ResetPasswordSection;